import { io } from "socket.io-client";

export function createRequestsSocket(token, hotelId = null, sinceCursor = null) {
  const api = process.env.REACT_APP_API_BASE || "https://api.kypser.com/api";
  const wsEnv = process.env.REACT_APP_WS_URL || "";
  const base = wsEnv || api.replace(/^http/, "ws").replace(/\/api$/, "");

  // If the second argument looks like a cursor (contains '-', 'T', or ':'), swap them
  if (typeof hotelId === 'string' && (hotelId.includes('-') || hotelId.includes('T'))) {
    sinceCursor = hotelId;
    hotelId = null;
  }

  return io(base, {
    path: "/socket.io",
    transports: ["websocket"],
    auth: { token, hotelId, since: sinceCursor },
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelayMax: 10000,
  });
}


